import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, styled } from '@mui/material';

export const FileFieldContainer = styled(Box)(() => ({
  marginBottom: '16px',
}));

export const FileInputBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'disabledCursor',
})(({ theme, disabledCursor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '32px',
  padding: '0 8px',
  border: `solid 1px ${theme.palette.colors.borderLine}`,
  borderRadius: '4px',
  cursor: disabledCursor ? 'default' : 'pointer',
}));

export const InsideBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '92%',
  flex: '1',
}));

export const VisuallyHiddenInput = styled('input')({
  height: '55px',
  opacity: '0',
  position: 'absolute',
  zIndex: '1300',
  display: 'none',
});

export const NameBox = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isPlaceholder',
})(({ theme, isPlaceholder }) => ({
  fontFamily: 'Roboto',
  fontSize: '12px',
  color: isPlaceholder
    ? theme.palette.colors.placeholderText
    : theme.palette.colors.onPrimaryBackground,
  fontWeight: isPlaceholder ? 'normal' : 500,
  fontStyle: isPlaceholder && 'italic',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const IconButtonStyled = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'disabledCursor',
})(({ disabledCursor }) => ({
  cursor: disabledCursor ? 'default' : 'pointer',
  padding: 0,

  '&:first-child': {
    marginRight: '8px',
  },
}));

export const IconStyled = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'disabledCursor',
})(({ theme, size, disabledCursor }) => ({
  fontSize: size,
  color: theme.palette.colors.mainFocused,
  cursor: disabledCursor ? 'default' : 'pointer',
}));

export const OverlayBox = styled(Box)(() => ({
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100vw',
  height: '100%',
  background: 'rgba(13, 59, 75, 0.65)',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  zIndex: '1300',
}));

export const MenuBox = styled(Box)(() => ({
  width: '100vw',
  zIndex: '1301',
  textTransform: 'uppercase',
}));
